<template>
  <div>
    <div class="display-flex justify-space-between align-center">
      <img
        src="../../assets/mobile/icon/arrow-left.svg"
        width="9"
        @click="$router.push({ name: 'YouMobile' })"
        height="18"
      />
      <img :src="require('@/assets/ys_logo_primary-black.svg')" width="100" />
      <div></div>
    </div>

    <div
      class="text-dmsans-14 text-white d-flex justify-center align-center font-weight-500 my-4 error full-width"
    >
      Checkout error
    </div>

    <Card @click="$router.push({ name: 'ConfirmationMobile' })" />
  </div>
</template>

<script>
import Card from "./components/card.vue";

export default {
  components: {
    Card,
  },
};
</script>

<style scoped>
.error {
  border-radius: 4px;
  background: #ff5050;
  height: 29px;
}
</style>



// WEBPACK FOOTER //
// checkout.vue?ebbd22e8